import { render, staticRenderFns } from "./TovHeader.vue?vue&type=template&id=d45675f6&"
import script from "./TovHeader.vue?vue&type=script&lang=js&"
export * from "./TovHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports